angular.module('impactx.togglebutton').directive('ixToggleButtonGroup', function () {
    return {
        restrict: 'E',
        required: 'ngModel',
        transclude: true,
        templateUrl: 'shared/togglebutton/templates/toggle-button-group.tmpl.html',
        link: function (scope, element, attr) {
            scope.$watch(attr.ngModel, function (newModel) {
                if (newModel) {
                    scope.ngModel = newModel;
                }
                else {
                    scope.ngModel = 0;
                }
            });
        }
    }
});